module.exports = __webpack_public_path__ + "img/get-started-with-dpgo.756f8d24.png";